import React from 'react';
import styled from 'styled-components';
import { Tooltip, TooltipContent, TooltipTrigger } from './Tooltip';
import { Body } from '../../shared/styled-components/styled_text';

interface Props {
  message: string;
  color: 'red' | 'grey' | 'outline' | string;
  centerText?: boolean;
  size?: string;
  style?: React.CSSProperties;
  containerContent?: React.ReactNode;
  icon?: 'warning' | 'help';
}

export const WarningTooltip: React.FC<Props> = ({ message, color, centerText, size, style, containerContent, icon }) => {
  return (
    <Tooltip>
      <Container>
        <TooltipTrigger>
          {(!icon || icon === 'warning') && <Warning $color={color} $size={size} style={style} />}
          {icon === 'help' && <Help $color={color} $size={size} style={style} />}
        </TooltipTrigger>
        {containerContent}
      </Container>

      <TooltipContent>
        <Body size={'s'}>{message}</Body>
      </TooltipContent>
    </Tooltip>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.4rem;
`;

const Warning = styled.div<{ $color: 'red' | 'grey' | 'outline' | string; $size?: string }>`
  gap: 0.4rem;
  width: ${props => props.$size ?? '1.6rem'};
  height: ${props => props.$size ?? '1.6rem'};
  background-image: url('/images/common/warning_circle_${props => props.$color}.svg');
  background-size: cover;
`;

const Help = styled.div<{ $color: string; $size?: string }>`
  gap: 0.4rem;
  width: ${props => props.$size ?? '1.6rem'};
  height: ${props => props.$size ?? '1.6rem'};
  mask: url('/images/common/help.svg');
  mask-size: cover;
  background-color: ${props => props.$color};
`;
